<div class="alerts-container">
  <div
    #tooltip="matTooltip"
    matTooltip="State & time since last change"
    class="w-50 a-violet signal"
    [ngStyle]="foregroundDiffStyle"
  >
    <span>{{ foregroundTimer }}</span>
  </div>
  <div
    #tooltip="matTooltip"
    matTooltip="State & time since last change"
    class="w-50 a-grey signal"
    [ngStyle]="backgorundDiffStyle"
  >
  <span> {{ backgroundTimer }}</span>
  </div>
</div>
